import {BaseFilterModel} from "./baseFilter.model";

export class ConsolidatedFilter extends BaseFilterModel {
  subjectType: string = null; // тип субъекта
  name = ''; // ФИО / наименование организации
  birthDate = null; // Дата рождения
  number = ''; // номер документа удост.личность
  idSubject = ''; // Идентификатор записи
}
